export const BreadcrumbMap = {
  dashboard: { label: '', url: '/' },
  'metadata&statistic': { label: 'Metadaten Statistiken', url: '/metadata&statistic' },
  'metadata&statistic': { label: 'Metadaten Kenzahlen', url: '/metadata&key' },
  evaluation: { label: 'Auswertungen', url: '/evaluation' },
  statistics: { label: 'Auswertungstool', url: '/evaluation/statistics' },
  'tablesstandard&21311': { label: 'Standardtabellen Studierende', url: '/tablesstandard&21311' },
  'tablesstandard&21321': { label: 'Standardtabellen Prüfungen', url: '/tablesstandard&21321' },
  'tablesstandard&21341': { label: 'Standardtabellen Hochschulpersonal', url: '/tablesstandard&21341' },
  'tablesstandard&21351': { label: 'Standardtabellen Habilitationen', url: '/tablesstandard&21351' },
  'tablesstandard&21352': { label: 'Standardtabellen Promovierende', url: '/tablesstandard&21352' },
  'tablesstandard&21371': { label: 'Standardtabellen Hochschulfinanzen', url: '/tablesstandard&21371' },
  'keyfigures&nonmonetary': { label: 'Nicht-monetäre Kennzahlen', url: '/keyfigures&nonmonetary' },
  'keyfigures&monetary': { label: 'Monetäre Kennzahlen', url: '/keyfigures&monetary' },
  'tablessaved&personal': { label: 'Ordnerverzeichnis (Persönlicher Ordner)', url: '/tablessaved&personal' },
  'tablessaved&shared': { label: 'Ordnerverzeichnis (Gruppenordner)', url: '/tablessaved&shared' },
  'tablessaved&transfer': { label: 'Ordnerverzeichnis (Amtsinterner Ordner)', url: '/tablessaved&transfer' },
  'tablessaved&free': { label: 'Ordnerverzeichnis (Öffentlicher Ordner)', url: '/tablessaved&free' },
  changepassword: { label: 'Kennwort ändern', url: '/changepassword' },
  userdata: { label: 'Meine Benutzerdaten', url: '/userdata' },
  // Fachadministration
  useradmin: { label: 'Benutzerverwaltung', url: '/useradmin' },
  newuser: { label: 'Neuer Anwender', url: '/useradmin/newuser' },
  edituser: { label: 'Benutzerdaten/Zugriffsrechte', url: '/useradmin/edituser' },
  releaseobjects: { label: 'Freigabe von Nutzer-Objekten', url: '/releaseobjects' },
  referencedata: { label: 'Referenzmetadaten', url: '/referencedata' },
  importpage: { label: 'Import', url: '/importpage' },
  datastock: { label: 'Datenbestände', url: '/datastock' },
  requestdata: { label: 'Datenabfrage', url: '/requestdata' },
  importlist: { label: 'Übersicht Aufträge', url: '/importlist' },
  // Beispiele
  empty: { label: 'leer', url: '/empty' },
  importpagetest: { label: 'Import Test', url: '/importpagetest' },
  example: { label: 'Tabellen', url: '/example' },
};
